import { render } from "./Vergaarbak.vue?vue&type=template&id=2e25f900"
import script from "./Vergaarbak.vue?vue&type=script&lang=js"
export * from "./Vergaarbak.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__